export const SNACKBAR = '@state/snackbar';
export const SHOW = '@state/show';
export const NO_SHOW = '@state/noShow';
export const INITIALIZING = '@state/initializing';
export const ROUTING = '@state/routing';
export const CHECKING_DEEPLINK = '@state/checking_deeplink';
export const NO_RESULTS = '@state/no_results';
export const NO_MLOC_DATA = '@state/no_mloc_data';
export const ERROR = '@state/error';
export const DONE = '@state/done';
export const IDLE = '@state/idle';
export const IDLE_MAP_SEARCH = '@state/idleMapSearch';
export const FETCHING_PROVIDERS = '@state/fetching_providers';
export const FETCHING_LOCATIONS = '@state/fetching_locations';
export const LOADING_MORE_PROVIDERS = '@state/loading_more_providers';
export const PROVIDER_DRAWER_OPEN = '@state/provider_drawer_open';
export const RENDER_PROVIDERS = '@state/render_providers';
export const RENDER_SINGLE_LOCATION = '@state/render_single_location';
export const BOOKING_CTA_MODAL_OPEN = '@state/booking_cta_modal_open';
export const SORT_AND_FILTER_DRAWER_OPEN = '@state/sort_and_filter_drawer_open';
export const CLOSED = '@state/closed';
export const FETCHING_PROVIDERS_AND_LOCATIONS =
  '@state/fetching_providers_and_locations';

// states for the parallel machine
export const INITIALIZED = '@state/initialized';
export const PROVIDER_DRAWER = '@state/provider_drawer';
export const SORT_AND_FILTER_DRAWER = '@state/sort_and_filter_drawer';
export const MAP = '@state/map';
export const OPEN = '@state/open';
export const DISABLED = '@state/disabled';
